import DataGroupOverview from './DataGroupOverview'
import angular from 'angular'

export default angular
  .module('components.tb.dataGroupOverview', ['react'])
  .directive(
    'tbDataGroupOverview',
    (reactDirective, $auth, $http, StoreService) =>
      reactDirective(DataGroupOverview, [], {}, { $auth, $http, StoreService })
  )
